/**
 * THE SWAP POINT.
 *
 * No UI file imports an SFU SDK. The real LiveKit provider is the DEFAULT; the
 * simulator stays reachable behind `VITE_USE_MOCK=true` so the meeting UI can
 * still be demoed with no server in reach.
 */
import type { MediaClient } from './contract';
import { createLiveKitMediaClient } from './livekitProvider';
import { USE_MOCK } from './mediaEnv';
import type { MediaRoomSeed } from './roomSeed';
import { createSimulatedMediaClient } from './simulatedProvider';

export type MediaProviderKind = 'simulated' | 'livekit';

export const MEDIA_PROVIDER: MediaProviderKind = USE_MOCK ? 'simulated' : 'livekit';

export function createMediaClient(seed: MediaRoomSeed): MediaClient {
  return USE_MOCK ? createSimulatedMediaClient(seed) : createLiveKitMediaClient(seed);
}
